// eslint-disable

const routes = [

  // Full Page Layout
  {
    path: '/u',
    component: () => import('@/layouts/FullPage/FullPage'),
    children: [
      {
        path: '/magic-link-verification',
        name: 'ShopMLVerification',
        component: () => import('@/views/pages/ShopMLVerificationPage.vue'),
        props: (route) => ({ magicLinkToken: route.query.token }),
        meta: {
          guestOnly: true,
        },
      },
      {
        path: '/connexion-magasin',
        name: 'ShopSignIn',
        component: () => import('@/views/pages/ShopSignInPage/Index.vue'),
        meta: {
          guestOnly: true,
        },
      },
      {
        path: '/choix-utilisateur',
        name: 'Login',
        component: () => import('@/views/pages/UserLoginPage/Index.vue'),
        props: true,
        meta: {
          shopAuth: true,
        },
      },
      {
        path: '/logout',
        name: 'Logout',
        component: () => import('@/views/pages/Logout'),
        meta: { auth: true },
      },
      {
        path: '/deconnexion-magasin',
        name: 'ForgetShop',
        component: () => import('@/views/pages/ForgetShop'),
        meta: { shopAuth: true },
      },
    ],
  },
  {
    path: '/app',
    name: 'Dashboard',
    component: () => import('@/layouts/AppLayout/AppLayout'),
    redirect: { name: 'NewReception' },
    children: [
      {
        path: '/nouvelle-reception',
        name: 'NewReception',
        component: () => import('@/views/pages/NewReceptionPage/Index.vue'),
        meta: { auth: true },
      },
      {
        path: '/bons-de-livraison/:supplierId',
        name: 'ChooseBonDeLivraison',
        component: () => import('@/views/pages/ChooseBonDeLivraisonPage/Index.vue'),
        meta: { auth: true },
        props: true,
      },
      {
        path: '/produits-fournisseur/:supplierId/:bonDeLivraisonId',
        name: 'SupplierProducts',
        component: () => import('@/views/pages/SupplierProductsPage/Index.vue'),
        meta: { auth: true },
        props: true,
      },
    ],
  },
  {
    name: 'Home',
    path: '/*',
    redirect: { name: 'Dashboard' },
  },
];

export default routes;
